import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';




class PaymentMethods extends Component {
  render() {
    return (
      <div className='RewardsOptions'>
        <img className='logo' src={logo}></img>
        <br />
        <div>
          How Do You Want to Fill to Your Wallet...
        </div>
        <br />
        <div><Link to='/coinsoptions'>Thai Banks Transfer</Link></div>
        <br />
        <div><Link to='/creditcardoptions'>Credit Cards</Link></div>
        <br />
          <br />
          <div>Powered by</div>
          <img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
        </div>
    );
  }
}
export default PaymentMethods;
